<h2>{{ data.title }}</h2>
<mat-divider></mat-divider>
<p class="mt-5 mb-5">{{ data.message }}</p>
<button mat-raised-button [mat-dialog-close]="false">
  {{ data.cancelText }}
</button>
<button
  color="primary"
  mat-raised-button
  [mat-dialog-close]="true"
  cdkFocusInitial
  class="float-right"
>{{ data.confirmText }}</button>
